import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@mui/material';
import { FormChangeSource } from '../../../cinnamon-core/es/components/forms/constants.js';
import FormContext$1 from '../../../cinnamon-core/es/components/forms/FormContext.js';

var _excluded = ["as", "field", "populate", "arrayKey", "onAdded"];
var DEFAULT_ARRAY_KEY = "key";

var DEFAULT_POPULATE = function DEFAULT_POPULATE(arrayKey) {
  return _defineProperty({}, arrayKey, Date.now());
};
/**
 * Button to append a new item into a form array
 */


var ArrayAdder = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayAdder, _React$Component);

  var _super = _createSuper(ArrayAdder);

  function ArrayAdder() {
    var _this;

    _classCallCheck(this, ArrayAdder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          field = _this$props.field,
          _this$props$populate = _this$props.populate,
          populate = _this$props$populate === void 0 ? DEFAULT_POPULATE : _this$props$populate,
          _this$props$arrayKey = _this$props.arrayKey,
          arrayKey = _this$props$arrayKey === void 0 ? DEFAULT_ARRAY_KEY : _this$props$arrayKey,
          onAdded = _this$props.onAdded;
      var next = populate(arrayKey);

      var applyChanges = function applyChanges(prevValue) {
        var prevArrayValue = prevValue[field] || [];
        return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, field, [].concat(_toConsumableArray(prevArrayValue), [next])));
      };

      var metadata = {
        source: FormChangeSource.Array
      };

      if (_this.context.onChange) {
        _this.context.onChange(field, applyChanges(_this.context.value || {})[field], applyChanges, metadata);
      }

      if (onAdded) onAdded(next);
    });

    return _this;
  }

  _createClass(ArrayAdder, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as;
          _this$props2.field;
          _this$props2.populate;
          _this$props2.arrayKey;
          _this$props2.onAdded;
          var otherProps = _objectWithoutProperties(_this$props2, _excluded);

      var Component = as;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return ArrayAdder;
}(React.Component);

_defineProperty(ArrayAdder, "defaultProps", {
  arrayKey: DEFAULT_ARRAY_KEY,
  as: Button,
  populate: DEFAULT_POPULATE
});

_defineProperty(ArrayAdder, "contextType", FormContext$1);

var ArrayAdder$1 = ArrayAdder;

export { ArrayAdder$1 as default };
